import { Container, Mesh, Program, PlaneGeometryBuffer} from 'beam';
import CubicBezier from './helpers/cubicBezier';
import gridVertexShader from './shaders/grid-vs.glsl'
import gridFragmentShader from './shaders/grid-fs.glsl'

export default class SpeedEffect {
    constructor(renderer) {
        this.renderer = renderer;
        this.currGridsProgress = 0;
        this.container = new Container();
        this.grids  = [];
        this.grids2 = [];
        for (let i=0; i<10; i++) {
            const grid = new Mesh();
            grid.geometry = new PlaneGeometryBuffer(this.renderer.gl, {
                width:  2000, 
                height: 1000, 
                widthSegments:  20,
                heightSegments: 10,
            });
            grid.material = new Program(this.renderer.gl, {
                blend:          true,
                vertexShader:   gridVertexShader,
                fragmentShader: gridFragmentShader,
                type:           this.renderer.gl.POINTS,
                uniforms: {
                    uInfiniteGrid: 1,
                    uPointScale: 1,
                }
            });
            this.container.add(grid);
            this.grids.push(grid);

            const grid2 = new Mesh();
            grid2.geometry = new PlaneGeometryBuffer(this.renderer.gl, {
                width:  2000, 
                height: 1000, 
                widthSegments:  20,
                heightSegments: 10,
            });
            grid2.material = new Program(this.renderer.gl, {
                blend:          true,
                vertexShader:   gridVertexShader,
                fragmentShader: gridFragmentShader,
                type:           this.renderer.gl.POINTS,
                uniforms: {
                    uPointScale: 1,
                    uInfiniteGrid: 1,
                }
            });
            grid2.position[0] = 50
            grid2.position[1] = 50
            this.container.add(grid2);
            this.grids2.push(grid2);
        }
    }

    update(e, camera) {
        this._scroll              = e;
        const progress            = Math.max(0, Math.min(1, this._scroll / (window.innerHeight )));
        const easedProgress       = CubicBezier( 0.850, 0.025, 0.145, 0.975, progress, 1 );
        const progress2           = Math.max(0, Math.min(1, (this._scroll - window.innerHeight) / (window.innerHeight )));
        const easedProgress2      = CubicBezier(0.850, 0.025, 0.145, 0.975, progress2, 1 );
        const speedEffectOpacity  =  CubicBezier( 0.430, 0.195, 0.445, 0.780, progress, 1 );;
        const speedEffectOpacity2 =  CubicBezier( 0.430, 0.195, 0.445, 0.780, progress2, 1 );;
        this.currGridsProgress += ( ( ( easedProgress + easedProgress2 ) ) - this.currGridsProgress) * 0.1;
        this.grids.forEach((grid, i)=>{
            grid.scale[0] =
            grid.scale[1] =
            grid.scale[2] =  (window.innerHeight *2) / 2000;
            grid.position[2] =  ((-500 * i )  + ((this.currGridsProgress * window.innerHeight * 3) % 1000 )) ;
            grid.updateMatrix()
            grid.updateWorldMatrix()
            grid.material.uniforms.uPointScale.value        =Math.abs( Math.sin((speedEffectOpacity + speedEffectOpacity2) % 1 * Math.PI ) );
        });
        this.grids2.forEach((grid, i)=>{
            grid.scale[0] =
            grid.scale[1] =
            grid.scale[2] =  (window.innerHeight *2) / 2000;
            grid.position[2] = ((-500 * i )  + ((this.currGridsProgress * window.innerHeight * 3) % 1000 )) ;
            grid.updateMatrix()
            grid.updateWorldMatrix()
            grid.material.uniforms.uPointScale.value        = Math.abs( Math.sin((speedEffectOpacity + speedEffectOpacity2) % 1 * Math.PI ) );
        });
        this.container.position = camera.position
        // console.log('dd', Math.abs( Math.sin((speedEffectOpacity + speedEffectOpacity2) % 1 * Math.PI ) ));
    }
}